import { datadogLogs } from '@datadog/browser-logs';

export function initializeDatadog() {
  // Initialize Datadog
  // Ensure we've been given something for the secrets and values we need to
  // post anything of value.
  if (
    process.env.DD_ENV &&
    process.env.DD_APPLICATION_ID &&
    process.env.DD_CLIENT_TOKEN
  ) {
    // These options are common to all DD modules
    const commonDdOptions = {
      applicationId: String(process.env.DD_APPLICATION_ID),
      clientToken: String(process.env.DD_CLIENT_TOKEN),
      site: String(process.env.DD_SITE || 'datadoghq.eu'),
      service: 'sofar-client',
      env: String(process.env.DD_ENV),
    };

    if (process.env.DD_RECORD_LOGS === 'true') {
      datadogLogs.init({
        ...commonDdOptions,
        forwardErrorsToLogs: true,
        forwardConsoleLogs: 'all',
        sessionSampleRate: 100,
      });
    }
  }
}
